/*
 * Drives the five standard document cards. `typeKey` matches documentInvoiceType
 * in src/constants (tc / bilti / dkt / ewaybill / delivery_receipt); `field` is
 * the invoice property the file path(s) live on; `isArray` marks the multi-file
 * fields. `titleKey` is a strings() key, resolved in the card. `buyerOnly` cards
 * are hidden for supplier invoices. `viewField`, when set, is the array property the
 * card displays from (uploads / deletes still go through `field`). `singleTile`
 * renders one icon that opens all files in the viewer.
 */
const DOCUMENT_CONFIGS = [
	{ typeKey: 'invoice', field: 'invoice_document', isArray: false, titleKey: 'invoice', hideUploadWhenPresent: true },
	{ typeKey: 'delivery_receipt', field: 'delivery_receipt', viewField: 'delivery_receipts', singleTile: true, isArray: false, titleKey: 'delivery_receipt', buyerOnly: true },
	{ typeKey: 'ewaybill', field: 'eway_bill_document', isArray: false, titleKey: 'ewaybill' },
	{ typeKey: 'tc', field: 'tc_received', isArray: true, titleKey: 'test_certificate' },
	{ typeKey: 'dkt', field: 'dkt_documents', isArray: true, titleKey: 'dharamkata_slip' },
	{ typeKey: 'bilti', field: 'bilty_document', isArray: false, titleKey: 'bilti' },
	{ typeKey: 'stockPhotos', field: 'product_photos', isArray: true, titleKey: 'stock_photo', supplierOnly: true },
]

export default DOCUMENT_CONFIGS
